/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Communicator from '../Server/Communicator';
import PlayResultComponent from '../Server/PlayResultComponent';
import StateDependencyComponent from '../StateManager/StateDependencyComponent';
import StateEvent from '../StateManager/StateEvent';
import { StateID } from '../StateManager/StateID';
import StateReference from '../StateManager/StateReference';
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import { ReferenceGroup } from '../Utility/Component/ComponentReference/ReferenceGroup';
import RecoveryManager from './RecoveryManager';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** State component to check if there are more bonus spins available and branches accordingly. */
@cc._decorator.ccclass
export default class CheckMoreSpins extends StateDependencyComponent
{
    /** The state on which to check for more bonus spins. */
    @property({ type: StateReference, visible: true })
    private _checkOnState: StateReference = new StateReference(StateID.Bonus, true, ReferenceGroup.BonusGame_0);

    /** @hidden */
    private _communicatorRef: InjectableComponent<Communicator> = new InjectableComponent();

    /** @hidden */
    private _playResultRef: InjectableComponent<PlayResultComponent> = new InjectableComponent();

    /** @hidden */
    private _recoveryManagerRef: InjectableComponent<RecoveryManager> = new InjectableComponent();

    /** @hidden */
    protected setContexts(): void
    {
        this._communicatorRef.SetContext(Communicator);
        this._playResultRef.SetContext(PlayResultComponent);
        this._recoveryManagerRef.SetContext(RecoveryManager);
    }

    /** @hidden */
    protected start(): void
    {
        super.start([this._checkOnState]);
    }

    /** @hidden */
    protected onStateChangeHandler = (event: StateEvent): void =>
    {
        switch (event.State)
        {
            case this._checkOnState.Value:
                this.checkSpins();
                break;
        }
    }

    /** Checks the most recent play result for remaining bonus spins and branches accordingly. */
    private checkSpins(): void
    {
        const remainingSpins: number = this._playResultRef.Value.GetRemainingSpins();
        if (remainingSpins > 0)
        {
            this._recoveryManagerRef.Value.RecoveryCurrentPlayID++;
            this.completeStateOptionalNext(this._checkOnState.Value);
        }
        else
        {
            this.completeState(this._checkOnState.Value);
        }
    }
}
